import { useAct } from 'FlowBuilder/store'
import CodeMirrorEditor from 'Shared/components/CodeMirrorEditor'

const JsonField = ({name, value, onChange}) => {
  const act = useAct()
  const [showFieldsError, setShowFieldsError] = useState(false)

  const updateFields = (val) => {
    try {
      JSON.parse(val)
      setShowFieldsError(false)
      act.builder.setTemplateValidationErrors([])
      onChange(JSON.parse(val))
    }
    catch (error) {
      setShowFieldsError(true)
      act.builder.setTemplateValidationErrors([`${name} JSON is invalid`])
    }
  }

  return (
    <>
      <label className="margin-bottom half">{name}</label>
      <CodeMirrorEditor
        value={JSON.stringify(value, null, 2)}
        onChange={updateFields}
        mode='json'
      />
      {showFieldsError && (
        <p className="error">{name} JSON is invalid</p>
      )}
    </>
  )
}

export default JsonField
